import React from "react";
// eslint-disable-next-line no-unused-expressions
("use strict");
import { Dispatcher, NavigatorAction, NavigatorStore } from "../../flux";

/*
  Router child props:
    route: string: = The name that this route will be identified by. (required)
    initialRoute: bool = Is this the main route? (optional)
  Example:
  <Router>
    <Assignments
      route='assignments'
      {...this.props}
    />
    <Readings route='readings'/>
    <Book route='book'/>
  </Router>
  Notes:
    • If the initial route is not specified on any children, the first child listed will be used.
    • If more than one child is listed as being the initialRoute. The last one will be used.
*/

export default class Router extends React.Component {
  componentWillUnmount() {
    Dispatcher.unbind(
      Dispatcher.NAVIGATOR_STATE_CHANGE,
      "navigator-state-change"
    );
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 1);
  }

  componentDidMount() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 1);
    Dispatcher.bind(
      Dispatcher.NAVIGATOR_STATE_CHANGE,
      this.forceUpdate.bind(this),
      "navigator-state-change"
    );
    if (NavigatorStore.get().length === 0) {
      NavigatorAction.push(this.initialRoute().route);
    }
  }

  initialRoute() {
    let initialRoute = false;
    React.Children.forEach(this.props.children, child => {
      if (!initialRoute || child.props.initialRoute) {
        initialRoute = { route: child.props.route };
      }
    });
    return initialRoute;
  }

  renderScene(scene) {
    return React.Children.map(this.props.children, child => {
      if (scene.route === child.props.route) {
        return React.cloneElement(child, scene.props);
      }
    });
  }

  render() {
    const routeStack = NavigatorStore.get();
    if (routeStack.length > 0) {
      return (
        <div className="routing-navigator">
          {this.renderScene(routeStack[routeStack.length - 1])}
        </div>
      );
    }
    return null;
  }
}
